/**
 * Shared constants for Analytics, Competitors, and Dashboard
 *
 * Database field naming convention:
 * - instagram_daily_metrics: uses `scrape_date` for date, `scraped_at` for timestamp
 * - competitor_daily_metrics: uses `metric_date` for date
 */

export const POSTS_GOAL_WEEKLY = 3;
export const POSTS_GOAL_MONTHLY = 12;

export const BASELINE_TOLERANCE_DAYS = 2;
export const MAX_METRICS_DAYS = 45;

export const VIRAL_SCORE_BRACKETS = [
  { min: 70, max: 100, label: 'Wysoki', color: 'emerald' },
  { min: 40, max: 69, label: 'Średni', color: 'yellow' },
  { min: 0, max: 39, label: 'Niski', color: 'red' },
] as const;

/**
 * Count only posts that were ADDED (positive day-over-day deltas).
 * Instagram's posts_count can decrease when posts are deleted,
 * but we want to track content creation, not net change.
 *
 * @param dailyPostCounts - array of posts_count values sorted chronologically (oldest first)
 * @returns number of posts added (ignoring deletions)
 */
export function countPostsAdded(dailyPostCounts: number[]): number {
  let added = 0;
  for (let i = 1; i < dailyPostCounts.length; i++) {
    const delta = dailyPostCounts[i] - dailyPostCounts[i - 1];
    if (delta > 0) added += delta;
  }
  return added;
}
